import { ComponentProps, FC } from 'react'
import { styled } from '../../config'
import { DEFAULT_MARGIN } from './constants'
import { useSoundwave } from './hooks/useSoundwave'
import { SoundwaveOptions } from './types'

const Root = styled('svg', {
  stroke: '$white',
  strokeWidth: 1.2
})
export interface SoundwaveProps extends SoundwaveOptions, ComponentProps<typeof Root> {}

export const Soundwave: FC<SoundwaveProps> = ({
  margin = DEFAULT_MARGIN,
  url,
  lineId,
  ...props
}) => {
  const { length, svgRef } = useSoundwave({ margin, url, lineId })
  return (
    <Root ref={svgRef} {...props}>
      {Array.from({ length }).map((_, i) => {
        const x = margin * i
        return <line id={lineId} strokeLinecap="round" key={i} x1={x} x2={x} y1="50%" y2="50%" />
      })}
    </Root>
  )
}
